import { http } from 'services';

// Personal - Change password
export function personalChangePassword(payload, cbSuccess, cbError) {
  http.post(
    'personal/credentials/change-password',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Change email
export function personalChangeEmail(payload, cbSuccess, cbError) {
  http.post(
    'personal/credentials/change-email',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Resend email verification token
export function personalResendEmailVerificationToken(payload, cbSuccess, cbError) {
  http.post(
    'personal/credentials/resend-email-verification-token',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}




// WEBPACK FOOTER //
// ./src/api/api-personal/api-personal-credentials.js